module.exports = __webpack_public_path__ + "static/media/dark-theme-overspeed-duration.e384e9b3.svg";